import script from "./statutory-report-table.vue?vue&type=script&setup=true&lang=js"
export * from "./statutory-report-table.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__